import { render, staticRenderFns } from "./TaskMoneyConfigxinyu.vue?vue&type=template&id=9f71d298&"
import script from "./TaskMoneyConfigxinyu.vue?vue&type=script&lang=js&"
export * from "./TaskMoneyConfigxinyu.vue?vue&type=script&lang=js&"
import style0 from "./TaskMoneyConfigxinyu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports